import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import DialogService from "primevue/dialogservice";
// import Ripple from "primevue/ripple";
import { type App, type Component, createApp } from "vue";

// this function is a temporary solution to create a vue component from a vue file
// this function should create only one vue app and mount it to the container
// for now it creates a new vue app for every View Component

// define instance type for Vue component
export type VueComponentInstance<T> = T extends new (...args: any[]) => infer R ? R : never;

export function createVueViewComponent<T extends Component>(
    component: T,
    props: any,
    container: Element,
    addPrimeVue = true
): { mountedComponent: VueComponentInstance<T>; viewComponentApp: App<Element> } {
    const pinia = createPinia();

    const viewComponentApp = createApp(component, props);
    viewComponentApp.use(pinia);
    if (addPrimeVue) {
        viewComponentApp.use(PrimeVue);
        // viewComponentApp.use(PrimeVue, { ripple: true });
        viewComponentApp.use(DialogService);
        // viewComponentApp.directive("ripple", Ripple);
    }

    const mountedComponent = viewComponentApp.mount(container) as VueComponentInstance<T>;

    return {
        mountedComponent,
        viewComponentApp,
    };
}

export type VueMountedComponent<T extends Component> = {
    mountedComponent: VueComponentInstance<T>;
    componentApp: App<Element>;
};

export function createVueComponent<T extends Component>(
    component: T,
    props: any,
    container: Element,
    addPrimeVue = false
): VueMountedComponent<T> {
    const componentApp = createApp(component, props);
    if (addPrimeVue) {
        componentApp.use(PrimeVue);
    }
    const mountedComponent = componentApp.mount(container) as VueComponentInstance<T>;
   
    return {
        mountedComponent,
        componentApp,
    };
}

export function createEmptyDiv(): HTMLElement {
    return $("<div></div>").appendTo("body")[0];
}
